"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectEmpty = exports.getObjectToQueryString = exports.deleteCookies = exports.getCookies = exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const Constants = __importStar(require("./constants"));
const isObject_1 = __importDefault(require("lodash/isObject"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/***************************************************************************/
// COOKIE HELPERS (required)
/**
 * Set cookie
 * @returns void
 */
const setCookie = (cname, cvalue, exminutes) => {
    js_cookie_1.default.set(cname, cvalue, {
        domain: Constants.General.COOKIE_DOMAIN,
        expires: exminutes,
    });
};
exports.setCookie = setCookie;
/**
 * Get cookie
 * @returns string
 */
const getCookie = (cname) => {
    return js_cookie_1.default.getJSON(cname);
};
exports.getCookie = getCookie;
/**
 * Delete cookie
 * @returns void
 */
const deleteCookie = (cname) => {
    js_cookie_1.default.remove(cname, { domain: Constants.General.COOKIE_DOMAIN });
};
exports.deleteCookie = deleteCookie;
/**
 * Get cookies
 * @returns string[]
 */
const getCookies = (preface = "") => {
    var _a;
    const allCookies = js_cookie_1.default.get();
    const cacheCookieList = (_a = Object.keys(allCookies)) === null || _a === void 0 ? void 0 : _a.filter((key) => key === null || key === void 0 ? void 0 : key.startsWith(preface));
    return cacheCookieList || [];
};
exports.getCookies = getCookies;
/**
 * Delete cookies
 * @returns Promise<boolean>
 */
const deleteCookies = (preface = "") => {
    try {
        const cachedCookieList = (0, exports.getCookies)(preface);
        for (let index = 0; index < (cachedCookieList === null || cachedCookieList === void 0 ? void 0 : cachedCookieList.length); index++) {
            (0, exports.deleteCookie)(cachedCookieList[index]);
        }
        return Promise.resolve(true);
    }
    catch (error) {
        return Promise.reject(error);
    }
};
exports.deleteCookies = deleteCookies;
/***************************************************************************/
// GENERAL HELPERS
/**
 * Takes in OBJECT of keys and values and return query string with & and ?
 *  OBJECT -> "?page=2&limit=10&filter=js"
 * @returns string
 */
const getObjectToQueryString = (obj) => {
    if (!(0, isObject_1.default)(obj)) {
        return "";
    }
    if ((0, isEmpty_1.default)(obj)) {
        return "";
    }
    const queryParam = "?" +
        Object.keys(obj)
            .map((key) => {
            return `${key}=${encodeURIComponent(obj[key])}`;
        })
            .join("&");
    return queryParam;
};
exports.getObjectToQueryString = getObjectToQueryString;
/**
 * Takes in an OBJECT and checks if its either NULL, UNDEFINED or OBJECT has empty keys
 * @returns boolean
 */
const isObjectEmpty = (object) => {
    return (0, isEmpty_1.default)(object) || !Object.values(object).some((x) => !(0, isEmpty_1.default)(x));
};
exports.isObjectEmpty = isObjectEmpty;
//# sourceMappingURL=utils.js.map